"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logTitleStyles = exports.ERRORS = exports.RESERVED_EVENTS = exports.CONSOLE_MESSAGES = exports.WARNINGS = void 0;
exports.WARNINGS = {
    notInitialized: {
        title: "Not initialized",
        message: "Ensure that the service has been initialized at the very beginning of the application's lifecycle",
    },
    noNavigationContext: {
        title: "Missing navigation context",
        message: "Use navigation event first",
    },
    user: {
        title: "User already set",
        message: "User cannot be overwritten",
    },
};
exports.CONSOLE_MESSAGES = {
    user: {
        title: "User has been set",
    },
    clearUser: {
        title: "User has been cleared",
    },
    flushLogs: {
        title: "Logs flushed",
    },
};
exports.RESERVED_EVENTS = {
    navigation: "navigation",
    modal: "modal",
    modeValueFiltersChange: "modeValueFiltersChange",
    showTooltip: "showTooltip",
    columnResize: "columnResize",
    columnDataSort: "columnDataSort",
    externalLinkClick: "externalLinkClick",
    generateExcel: "generateExcel",
    copyToClipboard: "copyToClipboard",
    flushLogs: "flushLogs",
};
exports.ERRORS = {
    unauthorizedResponse: "Api response: 401 - unauthorized",
};
exports.logTitleStyles = {
    log: "color: #21ba45",
    warn: "color: #f2711c",
};
//# sourceMappingURL=const.js.map